/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { DayOfWeek } from '../../models/day-of-week';
import { UsageLoadDto } from '../../models/usage-load-dto';

export interface GetUsageLoadAverage$Params {
  from?: string;
  to?: string;
  weekday?: DayOfWeek;
  'X-API-Version'?: string;
}

export function getUsageLoadAverage(http: HttpClient, rootUrl: string, params?: GetUsageLoadAverage$Params, context?: HttpContext): Observable<StrictHttpResponse<UsageLoadDto>> {
  const rb = new RequestBuilder(rootUrl, getUsageLoadAverage.PATH, 'get');
  if (params) {
    rb.query('from', params.from, {});
    rb.query('to', params.to, {});
    rb.query('weekday', params.weekday, {});
    rb.header('X-API-Version', params['X-API-Version'], {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<UsageLoadDto>;
    })
  );
}

getUsageLoadAverage.PATH = '/api/usage-statistics/load/average';
